<template>
    <div id="dl_modal" class="download_contents">
        <div>
            <div @click="dlCanvas()">画像のみ</div>
            <div @click="dlCanvasWithInfo()">画像と製品情報</div>
            <div class="speech_bubble"></div>
            <div class="close_button" @click="closeModal()"><span class="round_btn"></span></div>
        </div>
    </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
    import SelectPosition from "./AddItem/SelectPosition";
    import ModalContent from "./ModalContent"

    export default {
        name: "DownloadContents",
        components: {SelectPosition, ModalContent},
        data: () => ({
            is_downloading: false,
        }),
        computed: {
        },
        methods: {
            ...mapMutations(["setModal", "setIsCreatingImage"]),
            ...mapMutations('simulator', ["deleteTempItem"]),
            ...mapActions(["resetTimer"]),
            ...mapActions('simulator', ["commitTempItem"]),
            closeModal(){
                const dl_modal = document.getElementById('dl_modal');
                dl_modal.classList.remove('open');
            },
            async dlCanvas() {
                const canvas = document.querySelector('.konvajs-content canvas');
                const link = document.createElement("a");
                link.href = canvas.toDataURL("image/png");
                link.download = "my_room_simulation.png";
                link.click();
            },
            async dlCanvasWithInfo() {
                this.setIsCreatingImage(true);
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";
        .download_contents {
            visibility: hidden;
            height: 0;
            padding: 10px 10px 0 10px;
            background-color: rgba(000, 000, 000, 0.7);
            border-radius: 3px;
            position: absolute;
            top: 0;
            left: 0;
            width: calc(100% - 20px);
            z-index: 5;
            > div {
                position: relative;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                > div {
                    width: 60%;
                    height: calc(50% - 30px);
                    padding: 10px;
                    font-size: 1vw;
                    text-align: center;
                    background-color: #fff;
                    border: 1px solid #040404;
                    margin-bottom: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    border-radius: 3px;
                }
                .speech_bubble {
                    position: absolute;
                    bottom: -50px;
                    right: 20px;
                    border-top: 20px solid rgba(000, 000, 000, 0.7);;
                    border-right: 20px solid transparent;
                    border-bottom: 20px solid transparent;
                    border-left: 20px solid transparent;
                    background-color: initial;
                    width: 0;
                    height: 0;
                    border-radius: 0;
                    display: block;
                    padding: 0;
                }
                .close_button {
                    position: absolute;
                    right: -20px;
                    top: -20px;
                    cursor: pointer;
                    background-color: initial;
                    width: initial;
                    height: initial;
                    border: none;
                    padding: 0;
                    .round_btn {
                        display: block;
                        position: relative;
                        width: 30px;
                        height: 30px;
                        border: 2px solid #343434;
                        border-radius: 50%;
                        background: #fff;
                    }
                    .round_btn::before, .round_btn::after {
                        content: "";
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        width: 3px;
                        height: 22px;
                        background: #343434;
                    }
                    .round_btn::before {
                        transform: translate(-50%, -50%) rotate(45deg);
                    }
                    .round_btn::after {
                        transform: translate(-50%, -50%) rotate(-45deg);
                    }
                    .round_btn:hover {
                        background: #343434;
                    }
                    .round_btn:hover::before, .round_btn:hover::after {
                        background: #fff;
                    }
                }
                @media (max-width: 739px) {
                    .speech_bubble {
                        position: absolute;
                        bottom: -30px;
                        right: 20px;
                        border-top: 10px solid rgba(000, 000, 000, 0.7);;
                        border-right: 10px solid transparent;
                        border-bottom: 10px solid transparent;
                        border-left: 10px solid transparent;
                    }
                    .close_button {
                        right: -24px;
                        top: -24px;
                        .round_btn {
                            width: 20px;
                            height: 20px;
                        }
                        .round_btn::before, .round_btn::after {
                            width: 3px; /* 棒の幅（太さ） */
                            height: 15px; /* 棒の高さ */
                        }
                    }
                }
            }
        }
    .download_contents.open {
        visibility: visible;
        height: calc(100% - 10px);
    }
</style>
